import React, { Component } from "react";
import CryptoJS from "crypto-js";
import config from "react-global-configuration";
import {
  EditorState,
  ContentState,
  RichUtils,
  convertFromHTML,
  convertToRaw,
  convertFromRaw,
  Modifier,
  CompositeDecorator,
} from "draft-js";
import { stateToHTML } from "draft-js-export-html";
import Editor, { createEditorStateWithText } from "@draft-js-plugins/editor";
import createToolbarPlugin, {
  Separator,
} from "@draft-js-plugins/static-toolbar";
import createEmojiPlugin from "@draft-js-plugins/emoji";
import {
  ItalicButton,
  BoldButton,
  UnderlineButton,
  CodeButton,
  HeadlineOneButton,
  HeadlineTwoButton,
  HeadlineThreeButton,
  UnorderedListButton,
  OrderedListButton,
  BlockquoteButton,
  CodeBlockButton,
} from "@draft-js-plugins/buttons";
import createLinkifyPlugin, { extractLinks } from "@draft-js-plugins/linkify";
import createMentionPlugin, {
  defaultSuggestionsFilter,
} from "@draft-js-plugins/mention";
import "@draft-js-plugins/static-toolbar/lib/plugin.css";
import "@draft-js-plugins/mention/lib/plugin.css";
import "@draft-js-plugins/linkify/lib/plugin.css";
import "./EditorToolbar.css";
import "@draft-js-plugins/emoji/lib/plugin.css";
//import editorStyles from './editorStyles.css';
const mentionPlugin = createMentionPlugin({ mentionPrefix: "@" });
const emojiPlugin = createEmojiPlugin({ useNativeArt: true });
const { MentionSuggestions } = mentionPlugin;
const { EmojiSuggestions, EmojiSelect } = emojiPlugin;
const linkifyPlugin = createLinkifyPlugin({
  target: "_blank",
});
const styles = {
  link: {
    color: "#2c82e3",
    textDecoration: "underline",
  },
};
function findLinkEntities(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === "LINK"
    );
  }, callback);
}

const Link = (props) => {
  const { url } = props.contentState.getEntity(props.entityKey).getData();
  return (
    <a href={url} style={styles.link}>
      {props.children}
    </a>
  );
};
export default class EditorNew extends Component {
  constructor(props) {
    super(props);
    const decorator = new CompositeDecorator([
      {
        strategy: findLinkEntities,
        component: Link,
      },
    ]);
    const inlineToolbarPlugin = createToolbarPlugin();
    this.PluginComponents = {
      Toolbar: inlineToolbarPlugin.Toolbar,
    };
    this.plugins = [
      inlineToolbarPlugin,
      linkifyPlugin,
      mentionPlugin,
      emojiPlugin,
    ];
    //    this.plugins = [linkifyPlugin,mentionPlugin];
    this.state = {
      apiUrl: this.decryptconfigdata("apiUrl"),
      editorState: EditorState.createEmpty(decorator),
      isMentionsOpen: false,
      suggestions: [],
    };
  }
  decryptconfigdata(configkey) {
    var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
    var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
    var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
      iv,
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return plaintext;
  }

  decrypt(findresponse, flg) {
    var key = CryptoJS.enc.Hex.parse(config.get("enc_key"));
    var iv = CryptoJS.enc.Hex.parse(config.get("enc_iv"));
    var res = flg ? findresponse.encdata : findresponse;
    var bytes = CryptoJS.AES.decrypt(res, key, { iv });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(plaintext);
  }

  componentDidMount() {
    // Focus on the editor once it is mounted

    if (this.props.users) {
      const users = Object.keys(this.props.users).map((item) => {
        return {
          ...this.props.users[item],
          id: this.props.users[item].emp_id,
          profile_image: this.props.users[item].profile_pic,
          profile_url: this.props.users[item].profile_url,
        };
      });
      this.setState({
        suggestions: users,
        mentionedUser: users,
      });
    }
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.edit_id !== this.props.edit_id) {
      this.setState({
        editorState: EditorState.createEmpty(),
      });
    }
  };

  onSeachChange1 = (srchval) => {
    if (srchval.value) {
      this.setState({
        suggestions: defaultSuggestionsFilter(
          srchval.value,
          this.state.mentionedUser
        ),
      });
    }
  };
  onOpenChange1 = (_open) => {
    this.setState({ isMentionsOpen: _open });
  };

  onChange = (editorState) => {
    this.setState({
      editorState,
    });
    const contentState = this.state.editorState.getCurrentContent();
    const raw = convertToRaw(contentState);
    const entityMap = raw.entityMap;
    var mention_data = [];
    Object.values(entityMap).map((entity) => {
      if (entity.data.mention !== undefined) {
        mention_data.push(entity.data.mention);
      }
    });

    let html = stateToHTML(contentState);
    if (mention_data != null && mention_data.length > 0) {
      for (var i = 0; i < mention_data.length; i++) {
        if (mention_data[i]) {
          var replace_str = "@" + mention_data[i].name;
          html = html.replace(
            replace_str,
            "<a target='_blank' href='https://intranet.muvi.com/viewEmployee/" +
              mention_data[i].id +
              "'>@" +
              mention_data[i].name +
              "</a>"
          );
        }
      }
    }
    mention_data = [];
    Object.values(entityMap).map((entity) => {
      if (entity.data.mention !== undefined) {
        mention_data.push(entity.data.mention.user_uuid);
      }
    });

    const linkifys = extractLinks(html);
    const parser = new DOMParser();
    if (linkifys != null && linkifys.length > 0) {
      const doc = parser.parseFromString(html, "text/html");
      const aTags = doc.getElementsByTagName("a");
      if (aTags.length > 0) {
        for (let i = 0; i < aTags.length; i++) {
          const aTag = aTags[i];
          const href = aTag.getAttribute("href");
          const text = aTag.innerText;
          const linkTag = doc.createElement("a");
          linkTag.setAttribute("href", href);
          linkTag.setAttribute("target", "_blank");
          linkTag.textContent = text;
          aTag.replaceWith(linkTag);
        }
        html = doc.body.innerHTML;
      } else {
        if (linkifys != null && linkifys.length > 0) {
          for (var i = 0; i < linkifys.length; i++) {
            if (linkifys[i]) {
              var replace_link = linkifys[i].url;
              html = html.replace(
                replace_link,
                "<a target='_blank' href='" +
                  linkifys[i].url +
                  "'>" +
                  linkifys[i].url +
                  "</a>"
              );
            }
          }
        }
      }
      //            html = doc.body.innerHTML;
    }
    const doc = parser.parseFromString(html, "text/html");
    const brTags = doc.querySelectorAll("br");
    brTags.forEach((ele) => ele.remove());
    html = html.replace(/<p><br[\/]?><[\/]?p>/g, "");
    var formData = {};
    const text = contentState.getPlainText().trim();

    var editorData = {};
    editorData.text = text;
    editorData.html_content = html;
    editorData.draft_js_content = raw;
    formData[this.props.field_name] = editorData;
    formData["mentioned_data"] = mention_data;
    this.props.getEditorData(formData);
  };

  focus = () => {
    this.editor.focus();
  };

  render() {
    const { Toolbar } = this.PluginComponents;
    return (
      <div className="editorContainerNote">
        <div className="upper-div chat_div">
          <div className="editors sec_div" onClick={this.focus}>
            <Editor
              editorState={this.state.editorState}
              onChange={this.onChange}
              plugins={this.plugins}
              ref={(element) => {
                this.editor = element;
              }}
            />
          </div>
          <MentionSuggestions
            open={this.state.isMentionsOpen}
            onOpenChange={this.onOpenChange1}
            suggestions={this.state.suggestions}
            onSearchChange={this.onSeachChange1}
          />
        </div>
        {this.props.show_toolbar ? (
          <div className="editorToolbar">
            <div className="editor-main">
              <Toolbar>
                {(externalProps) => (
                  <React.Fragment>
                    <BoldButton {...externalProps} />
                    <ItalicButton {...externalProps} />
                    <UnderlineButton {...externalProps} />
                    {/* <Separator {...externalProps} />
                  <UnorderedListButton {...externalProps} />
                  <OrderedListButton {...externalProps} /> */}
                  </React.Fragment>
                )}
              </Toolbar>
              {/* <div className="main-emoji">
                <EmojiSelect />
                <EmojiSuggestions />
              </div> */}
              <EmojiSuggestions />
            </div>
            <div class="note-btngrp">
              <button class="save-btn" onClick={this.props.noteAdd}>
                {this.props.noteAdding ? "Adding..." : "Add Note"}
              </button>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/EditorNew.js